<template>
  <div>
    <div v-if="item.hasTitle" class="d-flex flex-column">
      <div class="paragraph-title title-text">
        {{ item.title }}
      </div>
      <div class="d-flex align-center mt-2 mb-4">
        <!-- duration  -->
        <div v-if="item.duration" class="d-flex align-center mr-6">
          <img
            src="@/assets/icons/time.svg"
            style="height: 12px; width: auto"
            class="mr-2"
          />
          <div class="paragraph-caption">
            {{ item.duration }}
          </div>
        </div>

        <!-- distance  -->
        <div v-if="item.distance" class="d-flex align-center mr-6">
          <img
            src="@/assets/icons/distance.svg"
            style="height: 6px; width: auto"
            class="mr-2"
          />
          <div class="paragraph-caption">
            {{ item.distance }}
          </div>
        </div>

        <!-- pois -->
        <div v-if="item.pois" class="d-flex align-center">
          <img
            src="@/assets/icons/poi.svg"
            style="height: 12px; width: auto"
            class="mr-2"
          />
          <div class="paragraph-caption">
            {{ item.pois }}
            {{ $t("tour.stations") }}
          </div>
        </div>
      </div>
    </div>
    <!-- paragraph  -->
    <div v-html="item.paragraph" class="background--text"></div>

    <!-- button -->
    <div
      v-if="item.hasButton"
      class="mt-4 d-flex"
      style="width: 100%"
      @click="onButtonClick"
    >
      <div
        class="ml-auto important white--text d-flex align-center justify-space-between"
        style="
          text-align: center;
          height: 35px;
          width: 230px;
          border-radius: 18px;
          font-size: 17px;
        "
      >
        <span class="pl-4" style="white-space: nowrap">
          {{ item.buttonText }}
        </span>

        <img
          v-if="item.buttonIcon != 'map.png'"
          :src="require(`@/assets/icons/${item.buttonIcon}`)"
          style="height: 28px; width: auto"
          class="mx-1 my-1"
        />

        <img
          v-else
          :src="require(`@/assets/icons/${item.buttonIcon}`)"
          style="height: 34px; width: auto"
          class="my-1"
        />
      </div>
    </div>

    <v-divider
      v-if="!item.isLast"
      style="opacity: 0.3"
      class="my-7 background"
    ></v-divider>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
  },

  methods: {
    onButtonClick() {
      if (this.item?.hasButtonAction) this.$router.push(`/${this.item.path}`);
    },
  },
};
</script>

<style scoped>
.paragraph-title {
  font-size: 23px;
  /* line-height: 45px; */
  font-weight: 500;
  color: var(--v-background-base);
  white-space: nowrap;
}

.paragraph-caption {
  font-size: 14px;
  font-weight: 300;
  color: var(--v-darkgrey-base);
  line-height: 12px;
}
</style>
